import styled from "styled-components";

export const Footer = styled.div`
  font-size: 11px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin: 2%;
  width: 96%;
  height: 10vh;

  a {
    text-decoration: none;
  }

  a:visited {
    color: #b66690;
  }

  a:hover {
    color: #7f0e59;
  }
`;
